const calculateLibraryDescriptionCount = (value: string, characterLimit: number): number =>
  characterLimit - value.length;

export default calculateLibraryDescriptionCount;
